import state from "./state";
import actions from "./actios";
import mutations from "./mutations";
import getters from "./getters";

export default { namespaced: true, state, actions, mutations, getters };
